import { render, staticRenderFns } from "./DamSubstituicao.vue?vue&type=template&id=be53d1de&scoped=true&"
import script from "./DamSubstituicao.vue?vue&type=script&lang=js&"
export * from "./DamSubstituicao.vue?vue&type=script&lang=js&"
import style0 from "./DamSubstituicao.vue?vue&type=style&index=0&id=be53d1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be53d1de",
  null
  
)

export default component.exports